<template>
    <main-content @delete="deleteCoupon">
        <action-bar v-if="$can('create', 'product')">
            <router-link :to=" '/stores/' + store_hashid + '/coupons/create' " class="btn btn-success">{{ $t('btn.add') }} {{ $t('store.btn.discount') }}</router-link>
            <button class="back-btn ml-2" @click="$router.push('/stores/')">
                {{ $t('label.back') }}<i class="pl-2 fa fa-arrow-left" style="color: white;"></i>
            </button>
        </action-bar>

        <filter-bar></filter-bar>
        <kt-datatable v-bind="datatableProps"></kt-datatable>
    </main-content>
</template>

<script>
    import { ApiUrl } from '@/common/api.service'
    import columns from './datatable/couponColumns'
    import actions from './datatable/couponActions'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import mainContent from '@/components/main-content'
    import actionBar from '@/components/custom/action-bar'
    import filterBar from '@/components/custom/filter-bar'

    export default {
        components: {
            mainContent,
            actionBar,
            filterBar
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                store_hashid: this.$route.params.store_hashid,
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "coupon_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('store/'+this.store_hashid+'/coupons'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: true,
                    sortable: true,
                    columns: columns,
                    actions: actions
                }
            }
        },
        methods:{
            deleteCoupon(id){}
        }
    }
</script>

<style scoped>
    .back-btn{
        padding: 9px;
        border: 0;
        border-radius: 3px;
        background-color:
                #4AB3F4;
        border-color:
                #4AB3F4;
        color:
                #ffffff;
    }

</style>